import { Link } from '@material-ui/core'
import IRelevantSpecialist from 'data/abitilies/interfaces/IRelevantSpecialist'
import * as React from 'react'
import SnackbarService from 'services/snackbars'
import { getIfLinkExist } from 'services/utils'

interface IProps {
  specialist: IRelevantSpecialist
}

interface IState {}

export class RelevantSpecialist extends React.Component<IProps, IState> {
  render() {
    const {
      specialist: { label, href }
    } = this.props
    const props = {
      href: getIfLinkExist(href, href, undefined),
      onClick: getIfLinkExist(href, undefined, () =>
        SnackbarService.showSnackbar('Coming Soon', 'info')
      )
    }
    return (
      <Link {...props} target="_blank" className="specialist link">
        {label}
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Abilities/RelevantSpecialist/index.tsx